import Header from "../components/Header"
import Footer from "../components/Footer"
import { ArrowRight } from "lucide-react"
import { StickyNavigation } from "../components/common/StickyNavgation"
import { AccessRect } from '../components/common/AccessRect'
import mainlandPricevolume from '../assets/images/mainland-pricevolume.png'
import mainlandMineFactors from '../assets/images/mainland-mineFactors.png'
import mainlandFactors from '../assets/images/mainland-factors.png'
import mainlandData from '../assets/images/mainland-data.jpg'
import { Link, useLocation } from "react-router-dom"
import { useEffect, useRef } from 'react'
import { TrialFormPage } from '@/components/common/Trial/TrialFormPage';

export default function MainlandChinaPage() {
  const products = [
    {
      title: 'Price-Volume Factors',
      picUrl: mainlandPricevolume,
      contents: [
        '1. The underlying data leverage market data (OHLCV).',
        '2. Factor Mining Method: expert-driven manual research.',
        '3. Easy to integrate: SFTP/API; data is delivered in machine-readable standardized formats.'
      ]
    },
    {
      title: 'Model-Mined Factors',
      picUrl: mainlandMineFactors,
      contents: [
        '1. The underlying data leverage both market data (OHLCV) and exclusive alternative data.',
        '2. Factor Mining Method: machine learning/AI-driven mining to uncover nonlinear relationships and hidden signals.',
        '3. A team composed of financial researchers with backgrounds from leading domestic quantitative institutions and algorithm engineers.'
      ]
    },
    {
      title: 'Alternative Factors',
      picUrl: mainlandFactors,
      contents: [
        '1. The underlying data leverage exclusive alternative data.',
        '2. Factor Mining Method: expert-driven manual research.',
        '3. Designed for established quant teams, delivering incremental alpha beyond traditional price-volume data sources.'
      ]
    },
    {
      title: 'Alternative Data',
      picUrl: mainlandData,
      contents: [
        '1. Unlock proprietary alternative datasets—where potential investing signals transform into institutional-grade market insights.',
        '2. Empowering quant strategies with actionable signals—from alpha generation to timely risk mitigation.',
        '3. Laser-targeting the most explosive A-share sector/concept/ticker.'
      ]
    }
  ]

  const navigationItems = products.map((product, index) => {
    return (
      {
        id: index + 1,
        title: product.title,
        content: (
          <div className="container container-max-w mx-auto space-y-20">
            {
              index % 2 === 0 ? (
              <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 pb-[68px] mt-[63px] ${index !== products.length - 1 && 'border-b border-[#EFEFEF]'}`}>
                <div>
                  <img
                    src={product.picUrl}
                    alt="Price-Volume Factors"
                    className="h-[248px]"
                  />
                </div>
                <div>
                  <h2 className="text-4xl font-bold mb-[24px]">{product.title}</h2>
                  <ol className="space-y-1 text-[16px] mb-[48px] text-[#4D4D4D]">
                    {
                      product.contents.map(content => {
                        return (<li>{ content }</li>)
                      })
                    }
                  </ol>
                  <div className="text-[#0066FF] hover:text-[#297FFF] text-[20px] cursor-pointer">
                    <Link to="/data-product" className="font-bold group flex items-center">Learn More
                      <ArrowRight className="w-[24px] h-[24px] transition-transform duration-300 group-hover:translate-x-2 group-hover:text-[#297FFF] ml-[24px]" />
                    </Link>
                  </div>
                </div>
              </div>
              ) : (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 pb-[68px] border-b border-[#EFEFEF] mt-[63px]">
                  <div>
                    <h2 className="text-4xl font-bold mb-[24px]">{product.title}</h2>
                    <ol className="space-y-1 text-[16px] mb-[48px] text-[#4D4D4D]">
                      {
                        product.contents.map(content => {
                          return (<li>{ content }</li>)
                        })
                      }
                    </ol>
                    <div className="text-[#0066FF] hover:text-[#297FFF] text-[20px] cursor-pointer">
                      <Link to="/data-product" className="font-bold group flex items-center">Learn More
                        <ArrowRight className="w-[24px] h-[24px] transition-transform duration-300 group-hover:translate-x-2 group-hover:text-[#297FFF] ml-[24px]" />
                      </Link>
                    </div>
                  </div>
                  <div>
                    <img
                      src={product.picUrl}
                      alt="Price-Volume Factors"
                      className="h-[248px]"
                    />
                  </div>
                </div>
              )
            }
          </div>
        )
      }
      
    )
  })

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  const product = searchParams.get('product');

  const childRef = useRef();

  useEffect(() => {
    if (childRef.current && id && product) {
      childRef.current.scrollToSection(id, product)
    }
  }, []);
  return (
    <div className="min-h-screen">
      <Header scrollThreshold={715} />

      {/* Hero Section */}
      <section className="relative min-h-[70vh] flex items-center justify-center text-white font-titillium">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url('../assets/images/mainland-banner.png')]">
        </div>

        <div className="relative z-10 container container-max-w mx-auto">
          <div className="max-w-[865px]">
            <h1 className="text-[48px] font-bold mb-[12px] text-white">
              Your Quantitatively Engineered Bridge to China's Alpha
            </h1>
            <div className="text-lg">
              <p>
                <strong>Coverage:</strong> More than 5000 Stocks in A-Share market.
              </p>
              <p>
                <strong>Number of factors:</strong> Offering a library of over 600 Alpha factors, It is tailored to enhance your portfolio 
                construction and multi-factor strategies in the China A-Share market.
              </p>
              <p>
                <strong>Featured Sentiment Datasets:</strong> Powered by proprietary alternative data, our quantifiable sentiment 
                datasets decode real-time market psychology with institutional-grade precision.
              </p>
            </div>
          </div>
        </div>
      </section>
      <StickyNavigation items={navigationItems} heroHeight={500} navHeight={60} stickyNavHeight={96} ref={childRef}></StickyNavigation>
      <AccessRect></AccessRect>
      <TrialFormPage></TrialFormPage>
      <Footer />
    </div>
  )
}
